module.exports = __webpack_public_path__ + "img/2.bf67de59.png";